(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-explore-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activatePanel = (section, target) => {
      if (!section || !target) return;
      const tabs = Array.from(section.querySelectorAll('[data-bfe-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-bfe-panel]'));
      tabs.forEach((tab) => {
        const active = tab.dataset.bfeTab === target;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const active = panel.dataset.bfePanel === target;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-bf-explore]').forEach((section) => {
        if (section.dataset.bfeReady === 'true') return;
        section.dataset.bfeReady = 'true';
        section.querySelectorAll('[data-bfe-tab]').forEach((tab) => {
          tab.addEventListener('click', () => {
            activatePanel(section, tab.dataset.bfeTab);
          });
        });
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-bfe-panel]');
      if (!panel) return;
      const section = panel.closest('[data-bf-explore]');
      activatePanel(section, panel.dataset.bfePanel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-limited-deals"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

    const initCountdown = (timer) => {
      if (!timer || timer.dataset.initialized === 'true') return;
      timer.dataset.initialized = 'true';

      const endTime = Date.parse(timer.dataset.end || '');
      const days = timer.querySelector('[data-days]');
      const hours = timer.querySelector('[data-hours]');
      const minutes = timer.querySelector('[data-minutes]');
      const seconds = timer.querySelector('[data-seconds]');

      const render = () => {
        const remaining = Number.isFinite(endTime) ? Math.max(0, endTime - Date.now()) : 0;
        const totalSeconds = Math.floor(remaining / 1000);
        days.textContent = pad(Math.floor(totalSeconds / 86400));
        hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
        minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        seconds.textContent = pad(totalSeconds % 60);
        if (remaining <= 0 && timer.countdownInterval) {
          window.clearInterval(timer.countdownInterval);
        }
      };

      render();
      timer.countdownInterval = window.setInterval(render, 1000);
    };

    const copyCode = async (button) => {
      const code = button.dataset.copyCode || '';
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
      const label = button.querySelector('span');
      if (label && button.dataset.copySuccess) label.textContent = button.dataset.copySuccess;
    };

    const initSection = (root = document) => {
      root.querySelectorAll('[data-bf-countdown]').forEach(initCountdown);
    };

    initSection();
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-copy-code]');
      if (button) {
        event.preventDefault();
        copyCode(button);
      }
    });
    document.addEventListener('shopify:section:load', (event) => initSection(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-why-geekom-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('[data-bf-why]').forEach((section) => {
        if (section.dataset.bfwReady === 'true') return;
        section.dataset.bfwReady = 'true';

        const modal = section.querySelector('[data-bfw-modal]');
        const player = section.querySelector('[data-bfw-player]');
        const closeButton = section.querySelector('[data-bfw-close]');

        const closeVideo = () => {
          if (!modal || !player) return;
          player.replaceChildren();
          if (document.fullscreenElement && document.exitFullscreen) {
            document.exitFullscreen().catch(() => {});
          }
          if (modal.open) modal.close();
        };

        section.querySelectorAll('[data-bfw-play]').forEach((trigger) => {
          trigger.addEventListener('click', async () => {
            if (!modal || !player || trigger.disabled) return;
            const kind = trigger.dataset.videoKind || '';
            const id = trigger.dataset.videoId || '';
            const url = trigger.dataset.videoUrl || '';
            let media;

            if (kind === 'hosted' && url) {
              media = document.createElement('video');
              media.src = url;
              media.controls = true;
              media.autoplay = true;
              media.playsInline = true;
            } else if (kind === 'youtube' && id) {
              media = document.createElement('iframe');
              media.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
              media.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
              media.allowFullscreen = true;
            } else if (kind === 'vimeo' && id) {
              media = document.createElement('iframe');
              media.src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
              media.allow = 'autoplay; fullscreen; picture-in-picture';
              media.allowFullscreen = true;
            } else {
              return;
            }

            player.replaceChildren(media);
            modal.showModal();

            if (kind === 'hosted') {
              media.play().catch(() => {});
            }

            try {
              if (modal.requestFullscreen) {
                await modal.requestFullscreen();
              } else if (kind === 'hosted' && media.webkitEnterFullscreen) {
                media.webkitEnterFullscreen();
              }
            } catch (error) {
              if (kind === 'hosted' && media.webkitEnterFullscreen) {
                media.webkitEnterFullscreen();
              }
            }
          });
        });

        closeButton?.addEventListener('click', closeVideo);
        modal?.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeVideo();
        });

        const track = section.querySelector('[data-bfw-track]');
        const slides = Array.from(section.querySelectorAll('[data-bfw-slide]'));
        const dots = section.querySelector('[data-bfw-dots]');
        const prev = section.querySelector('[data-bfw-prev]');
        const next = section.querySelector('[data-bfw-next]');
        if (!track || slides.length === 0 || !dots) return;
        let active = 0;

        const goTo = (index) => {
          active = (index + slides.length) % slides.length;
          track.scrollTo({ left: slides[active].offsetLeft, behavior: 'smooth' });
          dots.querySelectorAll('button').forEach((dot, dotIndex) => {
            dot.classList.toggle('is-active', dotIndex === active);
            dot.setAttribute('aria-current', dotIndex === active ? 'true' : 'false');
          });
        };

        slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bf-why__dot' + (index === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to review ' + (index + 1));
          dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          dot.addEventListener('click', () => goTo(index));
          dots.appendChild(dot);
        });

        prev?.addEventListener('click', () => goTo(active - 1));
        next?.addEventListener('click', () => goTo(active + 1));
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-bfw-slide]');
      if (!slide || window.innerWidth > 1024) return;
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geekom-back-to-top"]) return;
  try {
    
  if (!customElements.get('geekom-back-to-top')) {
    class GeekomBackToTop extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.threshold = Math.max(1, Number(this.dataset.showAfter) || 300);
        const signal = this.abortController.signal;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', () => {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: 0, left: window.scrollX, behavior: reducedMotion ? 'instant' : 'smooth' });
        }, { signal });
        const scheduleUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateState();
          });
        };
        window.addEventListener('scroll', scheduleUpdate, { passive: true, signal });
        window.addEventListener('resize', scheduleUpdate, { passive: true, signal });
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(scheduleUpdate);
        this.resizeObserver.observe(document.documentElement);
        this.resizeObserver.observe(document.body);
        this.updateState();
        this.hidden = false;
      }

      updateState() {
        const scrollRange = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const progress = scrollRange > 0 ? Math.min(1, Math.max(0, window.scrollY / scrollRange)) : 0;
        this.style.setProperty('--gtt-progress', progress.toFixed(4));
        const visible = scrollRange > 0 && window.scrollY >= this.threshold;
        this.classList.toggle('is-visible', visible);
        this.inert = !visible;
        this.setAttribute('aria-hidden', String(!visible));
        this.button.disabled = !visible;
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    }
    customElements.define('geekom-back-to-top', GeekomBackToTop);
  }

  } catch(e) { console.error(e); }
})();
})();
